import * as React from "react";

/**
 * Container component for the pharmacy page.
 * 
 */
class HealthplanWorkInProgress extends React.Component {

    render() {
        return (
            <div className="container-fluid body-content">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1>Health Plan work in progress</h1>
                    </div>
                </div>
            </div>
        );
    }

}

export default HealthplanWorkInProgress;
